import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Layout from "../Components/Layout/Layout";
import * as Yup from "yup";
import {
  Formik,
  Field,
  ErrorMessage,
  Form as FormikForm,
  FieldArray,
} from "formik";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  addChatBot,
  getChatBot,
  updateFile,
} from "../Redux/Actions/event";
import { toast } from "react-toastify";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import ExportModal from "../Components/ExportModal";

const validationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters"),
  color: Yup.string().required("Color is required"),
  questionLimits: Yup.string()
    .required("Question limits are required")
    .matches(/^\d+$/, "Question limits must be a valid number"),

  questionLimitType: Yup.string().required("Please select a limit type"),

  customMessageWhenLimitExceed: Yup.string().required(
    "custom message when limit exceed value is required"
  ),
  maxAllowedCharacters: Yup.string().required(
    "max allowed characters value is required"
  ),
  welcomeMessage: Yup.string()
    .trim()
    .required("Welcome message is required")
    .min(10, "Welcome message must be at least 10 characters"),
  // .max(100, "Welcome message must be less than 100 characters"),
  // prompt: Yup.string()
  //   .trim()
  //   .required("prompt message is required")
  //   .min(10, "prompt message must be at least 10 characters")
  //   .max(100, "prompt message must be less than 100 characters"),
  additionalLinks: Yup.array()
    .of(
      Yup.string()
        .url("Invalid URL")
        .required("Additional link is required")
    )
    .min(1, "At least one additional link is required"),
});

const timeOptions = [
  { value: "0", name: "per min" },
  { value: "1", name: "per hour" },
  { value: "2", name: "per day" },
  { value: "3", name: "per week" },
  { value: "4", name: "per month" },
  { value: "5", name: "per year" },
];

export default function AddNewChatboot() {

  const currentBot = useSelector((e) => e.botAuth.botDetails)
  const ImageUrl = process.env.REACT_APP_IMG_URL

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [loading, setLoading] = useState(false);

  const [logo, setLogo] = useState(null);
  const [icon, setIcon] = useState(null);
  const [sponsoredImage, setSponsoredImage] = useState(null);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const initialValues = {
    name: id ? currentBot?.name : '',
    welcomeMessage: id ? currentBot?.welcomeMessage : "",
    // prompt: id ? currentBot?.prompt : "",
    color: id ? currentBot?.color : "",
    additionalLinks: id ? currentBot?.additionalLinks : [""],
    customMessageWhenLimitExceed: id ? currentBot?.customMessageWhenLimitExceed : "",
    maxAllowedCharacters: id ? currentBot?.maxAllowedCharacters : "",
    questionLimitType: id ? currentBot?.questionLimitType : "",
    questionLimits: id ? currentBot?.questionLimits : "",
  };

  const uploadFile = async (file) => {
    let formData = new FormData();
    formData.append("image", file);
    try {
      let apiRes = await dispatch(updateFile(formData));
      let url = apiRes.payload.data.data.data.image;
      return url;
    } catch (error) { }
  };

  const handleSubmit = async (values) => {

    if (!logo) return toast.warn("Logo required");
    if (!icon) return toast.warn("Icon required");
    // const selectedTimeOption = timeOptions.find(
    //   (option) => option.value === values.questionLimitsValue
    // );

    setLoading(true);
    let logoUrl = logo ? await uploadFile(logo) : values.logo;
    let iconUrl = icon ? await uploadFile(icon) : values.icon;
    let sponsorUrl = sponsoredImage ? await uploadFile(sponsoredImage) : values.sponsoredImage;

    const updatedValues = {
      ...values,
      logo: logoUrl,
      icon: iconUrl,
      sponsoredImage: sponsorUrl,
      questionLimits: values.questionLimits,
      questionLimitstype: values.questionLimitType
      //  {
      //   [selectedTimeOption?.name.replace(/\s+/g, "")]: values.questionLimits,
      // },
    };
    if (id) updatedValues['chatbotId'] = currentBot.chatbotId
    try {
      await dispatch(addChatBot(updatedValues)).then((res) => {
        if (res.payload.status == 201 || res.payload.status === 200) {
          // toast.success(res?.payload?.message);
          navigate("/chatbots");
        } else {
          toast.error(res?.payload?.message);
          setLoading(false);
        }
      });
    } catch (error) {
      toast.error(error?.payload?.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(startstopLoading(true));
      dispatch(getChatBot({ id })).then(() => {
        dispatch(startstopLoading(false));
      });
    }
  }, [dispatch]);

  useEffect(() => {
    if (currentBot && id) {
      setLogo(currentBot?.logo)
      setIcon(currentBot?.icon)
      setSponsoredImage(currentBot?.sponsoredImage)
    }
  }, [currentBot])

  return (
    <Layout>
      <Container fluid>
        <div className="filters pb-2">
          <div className="inner-filter-field">
            <div className="image-heading-text d-flex justify-content-between align-item-center">
              <div className="" >
                <h2>{id ? 'Edit' : 'Add'} New Chatboot</h2>
              </div>
              {id &&
                <div className="create-btn m-0 p-0">
                  <button onClick={handleShow} >Export Chat</button>
                </div>
              }
            </div>
          </div>
          <div className=" new-tabs-add">
            {/* <div className="create-grneral-tab ">
              <p
                className={paramPath === "general" ? "grneral-active" : ""}
                onClick={() => navigate(`/add-new-chatbot?tab=general`)}
              >
                General
              </p>
              <p
                className={paramPath === "limit" ? "grneral-active" : ""}
                onClick={() => navigate(`/add-new-chatbot?tab=limit`)}
              >
                Limits
              </p>
            </div> */}

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({
                values,
                setFieldValue,
                setFieldTouched,
                setFieldError,
                handleSubmit,
                errors,
                touched,
              }) => (
                <FormikForm onSubmit={handleSubmit}>
                  <div className="create-notification-page new-tabs-add">
                    <div className="general-heading">
                      <h2>General</h2>
                    </div>

                    <div className="category-field">
                      <div className="general-box">
                        <div className="modal-input ">
                          <label>Chotbot name</label>
                          <Form.Group>
                            <Field
                              name="name"
                              type="text"
                              className="form-control"
                              placeholder="Enter your name"
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        <div className="textarea-input">
                          <Form.Group className="mt-4">
                            <Form.Label>Welcome Message</Form.Label>
                            <Field
                              name="welcomeMessage"
                              type="text"
                              className="form-control"
                              as="textarea"
                              rows={4}
                              placeholder="Enter here"
                            />
                            <ErrorMessage
                              name="welcomeMessage"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>
                        {/* <div className="textarea-input">
                          <Form.Group className="mt-4">
                            <Form.Label>prompt Message</Form.Label>
                            <Field
                              name="prompt"
                              type="text"
                              className="form-control"
                              as="textarea"
                              rows={4}
                              placeholder="Enter here"
                            />
                            <ErrorMessage
                              name="prompt"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div> */}
                      </div>
                      <div className="modal-input mt-3 ">
                        <label>Logo</label>
                        <Form.Group>
                          <input
                            type="file"
                            onChange={(e) => setLogo(e.target.files[0])}
                          />
                        </Form.Group>
                        {logo && (
                          <img
                            src={typeof logo === "string" ? ImageUrl + logo : URL.createObjectURL(logo)}
                            alt="Logo Preview"
                            style={{ width: 100, height: 100, marginTop: 10 }}
                          />
                        )}
                      </div>
                      <div className="modal-input mt-3">
                        <label>Icon</label>
                        <Form.Group>
                          <input
                            type="file"
                            onChange={(e) => setIcon(e.target.files[0])}
                          />
                        </Form.Group>
                        {icon && (
                          <img
                            src={typeof icon === "string" ? ImageUrl + icon : URL.createObjectURL(icon)}
                            alt="Icon Preview"
                            style={{ width: 100, height: 100, marginTop: 10 }}
                          />
                        )}
                      </div>
                      <div className="modal-input mt-3">
                        <label>Sponsored By Image</label>
                        <Form.Group>
                          <input
                            type="file"
                            onChange={(e) => setSponsoredImage(e.target.files[0])}
                          />
                        </Form.Group>
                        {sponsoredImage && (
                          <img
                            src={typeof sponsoredImage === "string" ? ImageUrl + sponsoredImage : URL.createObjectURL(sponsoredImage)}
                            alt="Sponsored By Image Preview"
                            style={{ width: 100, height: 100, marginTop: 10 }}
                          />
                        )}
                      </div>

                      <div className="color-theme mt-3    ">
                        <p>Color Theme</p>
                        <Form.Group>
                          <Field
                            name="color"
                            type="color"
                            className="form-control form-control-color"
                          />
                          <ErrorMessage
                            name="color"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </div>

                      <div className="modal-input mt-3">
                        <FieldArray name="additionalLinks">
                          {({ push, remove, form }) => (
                            <div className="modal-input mt-3">
                              <Form.Group className="mb-3 ">
                                <Form.Label>Additional Link</Form.Label>
                                {form?.values?.additionalLinks?.map(
                                  (link, index) => (
                                    <>
                                      <div
                                        key={index}
                                        className="d-flex align-items-center gap-2 mb-2"
                                      >
                                        <Field
                                          name={`additionalLinks[${index}]`}
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter link"
                                        />
                                        {/* Error message for this specific link */}

                                        {index > 0 && (
                                          <Button
                                            type="button"
                                            variant="danger"
                                            className="ms-2"
                                            onClick={() => remove(index)}
                                          >
                                            -
                                          </Button>
                                        )}
                                        <Button
                                          type="button"
                                          variant="primary"
                                          onClick={() => push("")}
                                        >
                                          +
                                        </Button>
                                      </div>
                                      <ErrorMessage
                                        name={`additionalLinks[${index}]`}
                                        component="div"
                                        className="text-danger"
                                      />
                                    </>
                                  )
                                )}
                              </Form.Group>
                            </div>
                          )}
                        </FieldArray>
                      </div>
                      {/* <div className="create-btn">
                        <button type="submit">Save</button>
                      </div> */}
                    </div>
                  </div>

                  <div className="create-notification-page new-tabs-add">
                    <div className="general-heading">
                      <h2>Limits</h2>
                    </div>
                    <div className="category-field">
                      <div className="input-select mb-3">
                        <label>Max No. of Quetions(eg. 100)</label>
                        <div className="select-the per">
                          <div className="modal-input">
                            <Form.Group>
                              <Field
                                name="questionLimits"
                                type="text"
                                className="form-control"
                                placeholder="Enter"
                              />
                              <ErrorMessage
                                name="questionLimits"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>
                          </div>
                          <div className="new-select-box">
                            <Field
                              id="questionLimitType"
                              as="select"
                              name="questionLimitType"
                              className="form-select"
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select
                              </option>
                              {timeOptions?.map((res) => (
                                <option key={res.value} value={res.value}>
                                  {res.name}
                                </option>
                              ))}
                            </Field>
                            <ErrorMessage
                              name="questionLimitType"
                              component="div"
                              className="text-danger"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="textarea-input">
                        <Form.Group className="mt-4">
                          <Form.Label>
                            Custom message When Limit Exceed
                          </Form.Label>
                          <Field
                            name="customMessageWhenLimitExceed"
                            type="text"
                            className="form-control"
                            as="textarea"
                            rows={4}
                            placeholder="Enter here"
                          />
                          <ErrorMessage
                            name="customMessageWhenLimitExceed"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </div>
                      <div className="modal-input mt-3">
                        <label>Max Allowed Characters in chatbot message</label>
                        <Form.Group>
                          <Field
                            name="maxAllowedCharacters"
                            type="text"
                            className="form-control"
                            placeholder="Enter"
                          />
                          <ErrorMessage
                            name="maxAllowedCharacters"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </div>

                      <div className="create-btn">
                        <button type="submit" disabled={loading}>
                          {loading ? "Loading..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
        <div className="made-with">
          <div className="pixinvent">
            <p>
              © {new Date().getFullYear()}, Made with ❤️ by{" "}
              <span>Codobux</span>
            </p>
          </div>
        </div>
      </Container>
      <ExportModal
        show={show} handleClose={handleClose} chatbotId={id}
      />

    </Layout>
  );
}
